import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  fetchPermissionUsersRequest,
  fetchPermissionUsersSuccess,
  fetchPermissionUsersFailure,
  updatePermissionUserAccessRequest,
  updatePermissionUserAccessSuccess,
  updatePermissionUserAccessFailure,
  removePermissionUserRequest,
  removePermissionUserSuccess,
  removePermissionUserFailure,
} from "../slices/permission.slice";
import {
  getPermissionUsers,
  updateUserAccessLevel,
  removeUserFromStore,
  GetPermissionUsersParams,
} from "@/services/permissionService";
import { toApiError } from "@/lib/errorHelpers";

function* fetchPermissionUsersSaga(
  action: PayloadAction<{ storeId: string; params?: GetPermissionUsersParams }>,
): Generator<any, void, any> {
  try {
    const { storeId, params = {} } = action.payload;
    const response = yield call(getPermissionUsers, storeId, params);

    yield put(
      fetchPermissionUsersSuccess({
        data: response.data || [],
        pagination: {
          page: response.pagination?.page || params.page || 1,
          total: response.pagination?.total || 0,
          pageSize: response.pagination?.pageSize || params.page_size || 10,
          totalPages: response.pagination?.totalPages || 1,
        },
      }),
    );
  } catch (error: any) {
    yield put(fetchPermissionUsersFailure(toApiError(error)));
  }
}

function* updatePermissionUserAccessSaga(
  action: PayloadAction<{
    storeId: string;
    userId: string;
    accessLevel: "seller" | "order_manager" | "staff";
  }>,
): Generator<any, void, any> {
  try {
    const { storeId, userId, accessLevel } = action.payload;
    const response = yield call(updateUserAccessLevel, storeId, userId, accessLevel);
    yield put(updatePermissionUserAccessSuccess(response));
  } catch (error: any) {
    yield put(updatePermissionUserAccessFailure(toApiError(error)));
  }
}

function* removePermissionUserSaga(
  action: PayloadAction<{ storeId: string; userId: string }>,
): Generator<any, void, any> {
  try {
    const { storeId, userId } = action.payload;
    yield call(removeUserFromStore, storeId, userId);
    yield put(removePermissionUserSuccess({ userId }));
  } catch (error: any) {
    yield put(removePermissionUserFailure(toApiError(error)));
  }
}

export function* permissionSaga(): Generator<any, void, any> {
  yield takeLatest(fetchPermissionUsersRequest.type, fetchPermissionUsersSaga);
  yield takeLatest(updatePermissionUserAccessRequest.type, updatePermissionUserAccessSaga);
  yield takeLatest(removePermissionUserRequest.type, removePermissionUserSaga);
}

export default permissionSaga;
